export const translations = {
  en: {
    instruction1: 'Please search for your health insurance by name or address:',
    paragraph1:
      'Insurance information is needed to bill for COVID-19 tests. Copayments and deductibles may apply based on insurance plan.',
    paragraph2: 'If additional insurance verification is needed, you may receive a follow-up call.',
    selectionBox: 'Choose your insurance',
    checkbox: "I can't find my insurance in above search."
  },
  es: {
    instruction1: 'Por favor, busque su seguro médico por nombre o dirección:',
    paragraph1:
      'Necesitamos la información del seguro para facturarle por las pruebas de COVID-19.  Pueden aplicarse copagos y deducibles según el plan de seguro. ',
    paragraph2:
      'Recibirá una llamada de seguimiento de ser necesario hacer una verificación adicional de su seguro.',
    selectionBox: 'Elija su seguro',
    checkbox: 'No encontré mi seguro médico en la búsqueda anterior.'
  }
};
